module.exports = __webpack_public_path__ + "static/media/stretch.e44c958a.jpg";